import { createFileRoute } from "@tanstack/react-router";

import CompanyPage from "@/pages/CompanyPage";

export const Route = createFileRoute("/_app/(people)/companies/$currentTab/$companyId")({
  component: () => <CompanyPage />,
});
